import { ReactNode } from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Fades + slides its children in when scrolled into view. Pass `index` for a
 * staggered cascade. No-ops (renders statically) under prefers-reduced-motion.
 */
const Reveal: React.FC<{
  children: ReactNode;
  index?: number;
  delay?: number;
  y?: number;
  className?: string;
}> = ({ children, index = 0, delay = 0, y = 18, className }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1], delay: delay + index * 0.08 }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
